export default __webpack_public_path__ + "i18n/languages.bdb4746.json";